// color.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ColorService {
  private colors = [
    '#2DBECD', // Blue
    '#A5CD50', // Green
    '#FFC832', // Yellow
    '#EB3C96', // Pink
  ];

  private usedColors: { [key: string]: number } = {};

  getRandomColor(): string {
    const colorCounts = this.colors.map((color) => ({
      color,
      count: this.usedColors[color] || 0,
    }));

    colorCounts.sort((a, b) => a.count - b.count);

    const selectedColor = colorCounts[0].color;

    this.usedColors[selectedColor] = (this.usedColors[selectedColor] || 0) + 1;

    return selectedColor;
  }
}
